import axios from ".";
import { User } from "../pages/playground/types";

export const adminGetAllUsers = async () => {
  return axios.get(`/admin/all-users`);
};

export const adminAddUser = async (user: User) => {
  return axios.post(`/admin/add-user`, user);
};

export const adminEditUser = async (user: User) => {
  return axios.post(`/admin/edit-user`, user);
};

export const disableUser = async (userId: string) => {
  return axios.post(`/admin/disable-user`, { user_id: userId });
};

export const enableUser = async (userId: string) => {
  return axios.post(`/admin/enable-user`, { user_id: userId });
};

// ======== Client Management ========

export type InviteClientData = {
  email: string;
  name: string;
  surname: string;
  organization_id: string;
  brand_ids?: string[];
};

export type EditClientData = {
  id: string;
  name: string;
  surname: string;
};

export type Client = {
  id: string;
  email: string;
  name: string;
  surname: string;
  organization_id?: string;
  role: string;
  email_confirmed: boolean;
  disabled: boolean;
};

export const inviteClient = async (client: InviteClientData) => {
  return axios.post(`/admin/invite-client`, client);
};

export const getClients = async () => {
  return axios.get(`/admin/clients`);
};

export const editClient = async (client: EditClientData) => {
  return axios.post(`/admin/edit-client`, client);
};

export const disableClient = async (clientId: string) => {
  return axios.post(`/admin/disable-client`, { client_id: clientId });
};

export const enableClient = async (clientId: string) => {
  return axios.post(`/admin/enable-client`, { client_id: clientId });
};

export const getClientBrandAuthorizations = async () => {
  return axios.get(`/admin/client-brand-authorizations`);
};

export const setClientBrandAuthorizations = async (
  clientId: string,
  brandIds: string[]
) => {
  return axios.post(`/admin/set-client-brand-authorizations`, {
    client_id: clientId,
    brand_ids: brandIds,
  });
};

export const resendClientInvite = async (clientId: string) => {
  return axios.post(`/admin/resend-client-invite`, { client_id: clientId });
};
